/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GeneralApiResponse } from '../models/general-api-response';
import { PspCustomerLocationItemResponse } from '../models/psp-customer-location-item-response';
import { PaginatedApiResponse } from '../models/paginated-api-response';

@Injectable({
  providedIn: 'root',
})
export class PspCustomerLocationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPspCustomerLocationList
   */
  static readonly GetPspCustomerLocationListPath = '/api/web/v1/psps/{psp}/locations';

  /**
   * Get list of Customer Locations.
   *
   * **Accessible only for users with permissions 'FEATURE_VIEW_RELATED_ORG', 'ROLE_PSP_ADMIN', 'ROLE_PSP_USER'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPspCustomerLocationList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspCustomerLocationList$Response(params: {
    psp: number;

    /**
     * Page number in pagination.
     */
    page?: any;

    /**
     * Size number in pagination.
     */
    size?: any;

    /**
     * Filter customer locations by ids
     */
    'customerLocations[]'?: any;

    /**
     * Search customer locations by name or legalName.
     */
    search?: any;

    /**
     * Filter customer locations by pspBranches ids
     */
    'branches[]'?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<PaginatedApiResponse & {
'data'?: Array<PspCustomerLocationItemResponse>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, PspCustomerLocationService.GetPspCustomerLocationListPath, 'get');
    if (params) {
      rb.path('psp', params.psp, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('customerLocations[]', params['customerLocations[]'], {});
      rb.query('search', params.search, {});
      rb.query('branches[]', params['branches[]'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaginatedApiResponse & {
        'data'?: Array<PspCustomerLocationItemResponse>;
        }>;
      })
    );
  }

  /**
   * Get list of Customer Locations.
   *
   * **Accessible only for users with permissions 'FEATURE_VIEW_RELATED_ORG', 'ROLE_PSP_ADMIN', 'ROLE_PSP_USER'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPspCustomerLocationList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPspCustomerLocationList(params: {
    psp: number;

    /**
     * Page number in pagination.
     */
    page?: any;

    /**
     * Size number in pagination.
     */
    size?: any;

    /**
     * Filter customer locations by ids
     */
    'customerLocations[]'?: any;

    /**
     * Search customer locations by name or legalName.
     */
    search?: any;

    /**
     * Filter customer locations by pspBranches ids
     */
    'branches[]'?: any;
    context?: HttpContext
  }
): Observable<PaginatedApiResponse & {
'data'?: Array<PspCustomerLocationItemResponse>;
}> {

    return this.getPspCustomerLocationList$Response(params).pipe(
      map((r: StrictHttpResponse<PaginatedApiResponse & {
'data'?: Array<PspCustomerLocationItemResponse>;
}>) => r.body as PaginatedApiResponse & {
'data'?: Array<PspCustomerLocationItemResponse>;
})
    );
  }

  /**
   * Path part for operation getAppApiWebV1PspLocationProfileEpCalculateIndex
   */
  static readonly GetAppApiWebV1PspLocationProfileEpCalculateIndexPath = '/api/web/v1/psps/{psp}/locations/{location}/profiles/{profile}/ep';

  /**
   * Calculate equals payment date.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_OFFERS'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppApiWebV1PspLocationProfileEpCalculateIndex()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppApiWebV1PspLocationProfileEpCalculateIndex$Response(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Profile Id.
     */
    profile: number;

    /**
     * Possible assignment start date.
     */
    possibleAssignmentStartDate: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GeneralApiResponse & {
'data'?: {
'ep_date'?: string;
};
}>> {

    const rb = new RequestBuilder(this.rootUrl, PspCustomerLocationService.GetAppApiWebV1PspLocationProfileEpCalculateIndexPath, 'get');
    if (params) {
      rb.path('psp', params.psp, {});
      rb.path('location', params.location, {});
      rb.path('profile', params.profile, {});
      rb.query('possibleAssignmentStartDate', params.possibleAssignmentStartDate, {"style":"form"});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneralApiResponse & {
        'data'?: {
        'ep_date'?: string;
        };
        }>;
      })
    );
  }

  /**
   * Calculate equals payment date.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_OFFERS'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAppApiWebV1PspLocationProfileEpCalculateIndex$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppApiWebV1PspLocationProfileEpCalculateIndex(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Profile Id.
     */
    profile: number;

    /**
     * Possible assignment start date.
     */
    possibleAssignmentStartDate: string;
    context?: HttpContext
  }
): Observable<GeneralApiResponse & {
'data'?: {
'ep_date'?: string;
};
}> {

    return this.getAppApiWebV1PspLocationProfileEpCalculateIndex$Response(params).pipe(
      map((r: StrictHttpResponse<GeneralApiResponse & {
'data'?: {
'ep_date'?: string;
};
}>) => r.body as GeneralApiResponse & {
'data'?: {
'ep_date'?: string;
};
})
    );
  }

  /**
   * Path part for operation getAppApiWebV1PspLocationProfileMlpCalculateIndex
   */
  static readonly GetAppApiWebV1PspLocationProfileMlpCalculateIndexPath = '/api/web/v1/psps/{psp}/locations/{location}/profiles/{profile}/mlp';

  /**
   * Calculate maximum lease period date.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_OFFERS'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppApiWebV1PspLocationProfileMlpCalculateIndex()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppApiWebV1PspLocationProfileMlpCalculateIndex$Response(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Profile Id.
     */
    profile: number;

    /**
     * Possible assignment start date.
     */
    possibleAssignmentStartDate: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<GeneralApiResponse & {
'data'?: {
'mlp_date'?: string;
};
}>> {

    const rb = new RequestBuilder(this.rootUrl, PspCustomerLocationService.GetAppApiWebV1PspLocationProfileMlpCalculateIndexPath, 'get');
    if (params) {
      rb.path('psp', params.psp, {});
      rb.path('location', params.location, {});
      rb.path('profile', params.profile, {});
      rb.query('possibleAssignmentStartDate', params.possibleAssignmentStartDate, {"style":"form"});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GeneralApiResponse & {
        'data'?: {
        'mlp_date'?: string;
        };
        }>;
      })
    );
  }

  /**
   * Calculate maximum lease period date.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_OFFERS'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAppApiWebV1PspLocationProfileMlpCalculateIndex$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppApiWebV1PspLocationProfileMlpCalculateIndex(params: {

    /**
     * PSP Id.
     */
    psp: number;

    /**
     * Location Id.
     */
    location: number;

    /**
     * Profile Id.
     */
    profile: number;

    /**
     * Possible assignment start date.
     */
    possibleAssignmentStartDate: string;
    context?: HttpContext
  }
): Observable<GeneralApiResponse & {
'data'?: {
'mlp_date'?: string;
};
}> {

    return this.getAppApiWebV1PspLocationProfileMlpCalculateIndex$Response(params).pipe(
      map((r: StrictHttpResponse<GeneralApiResponse & {
'data'?: {
'mlp_date'?: string;
};
}>) => r.body as GeneralApiResponse & {
'data'?: {
'mlp_date'?: string;
};
})
    );
  }

}
